import React from "react";
import { Progress } from "antd";

const RemainingDays = ({ creditpoints, availableAmount }) => {
  const totalCredits = Number(creditpoints) || 0; // Avoid division by zero
  const remainingCredits = Number(availableAmount) || 0;


  if (!totalCredits) {
    return <p>No data available for credits or available amount.</p>;
  }

  const percentage = ((remainingCredits / totalCredits) * 100).toFixed(2);

  

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
      <Progress
        type="circle"
        percent={Math.max(0, Math.min(100, percentage))}
        format={() => (
          <div style={{ fontSize: "14px", color: "#3C3C3C", fontWeight: "500" }}>
            {remainingCredits} <span style={{ fontSize: "12px", color: "#888" }}>credits</span>
          </div>
        )}
        strokeColor={{
          "0%": "#5A9FFA",
          "100%": "#3C8DC5",
        }}
      />
      <p style={{ fontSize: "14px", color: "#888" }}>
        {remainingCredits} credits remaining out of {totalCredits} credits
      </p>
    </div>
  );
};

export default RemainingDays;



